import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { authMutations } from '@as-react/common-queries';
import { EventEnum } from '@as-react/common-types';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import SessionStorageUtil from '../util/SessionStorageUtil';
import { BASKET_CHANGED, GUEST_EMAIL } from '../constants/StorageKeysConstants';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { EventUtil } from '@as-react/common-utils';
import { getLoginErrorMessage } from '../util/AuthUtil';
import { useWishlist } from './useWishlist';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
export const useCheckoutLogin = () => {
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState(null);
    const { defaultRequestParams, servicesEndpoint, root } = useAemConfig();
    const { wishlistLogin } = useWishlist();
    const { loginCheckoutMutation } = authMutations({ servicesEndpoint, defaultRequestParams });
    const { mutateAsync: loginCheckout } = useMutation(loginCheckoutMutation());
    const checkoutLogin = (_a) => __awaiter(void 0, [_a], void 0, function* ({ username, password, keepSignedIn, location }) {
        var _b, _c;
        setErrorMessage(null);
        try {
            const loginResponse = yield loginCheckout({ username, password, keepSignedIn });
            EventUtil.dispatch(EventEnum.LOGIN_SUCCESS);
            if (!loginResponse.readyForCheckout) {
                SessionStorageUtil.setItem(BASKET_CHANGED, true);
                window.location.href = `${root}checkout/basket-overview.html`;
                return;
            }
            dispatch(analyticsActions.loginStepOption(false));
            SessionStorageUtil.removeItem(GUEST_EMAIL);
            wishlistLogin();
            dispatch(basketActions.createGetBasicAction());
            EventUtil.dispatch(EventEnum.USER_LOGGED_IN, { loggedIn: true });
        }
        catch (e) {
            const error = e;
            const errorMessage = getLoginErrorMessage(Number((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error_code), location);
            setErrorMessage(errorMessage);
        }
    });
    return { checkoutLogin, errorMessage };
};
